<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <div class="row">
        <div class="columns small-12">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s18 rs-wd-m24 rs-h-s3 rs-h-m4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
          <div class="panel rs-panel-big clearfix">
            <div class="small-only-text-center">
              <div
                class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>

            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
            ></div>
            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>

            <div class="rs-ctable">
              <div class="row" role="list">
                <div class="small-12 medium-6 columns" role="listitem">
                  <div class="rs-ctable-panel jsrs-resizerContainer">
                    <div class="rs-ctable-panel-info-zone">
                      <div class="rs-ctable-panel-header jsrs-resizerPart" style="height: 67px">
                        <div class="small-only-text-center">
                          <div
                            class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                      <div class="jsrs-resizerPart" style="height: 70px">
                        <div
                          class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                        ></div>
                        <div
                          class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div
                        class="panel rs-maxw rs-h-s4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div class="rs-mh-s1"></div>
                    </div>
                    <div class="rs-ctable-panel-order-zone">
                      <div class="text-center">
                        <div
                          class="panel rs-inline-block rs-wd-s20 rs-wd-m30 rs-h-s3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div class="jsrs-resizerPart" style="height: 60px">
                        <div
                          class="panel rs-maxw rs-h-s4 rs-h-s4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div class="text-center">
                        <div
                          class="panel rs-inline-block rs-wd-s17 rs-wd-m23 rs-h-s3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="small-12 medium-6 columns" role="listitem">
                  <div class="rs-ctable-panel jsrs-resizerContainer">
                    <div class="rs-ctable-panel-info-zone">
                      <div class="rs-ctable-panel-header jsrs-resizerPart" style="height: 67px">
                        <div class="small-only-text-center">
                          <div
                            class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                      <div class="jsrs-resizerPart" style="height: 70px">
                        <div
                          class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                        ></div>
                        <div
                          class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div
                        class="panel rs-maxw rs-h-s4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div class="rs-mh-s1"></div>
                    </div>
                    <div class="rs-ctable-panel-order-zone">
                      <div class="text-center">
                        <div
                          class="panel rs-inline-block rs-wd-s20 rs-wd-m30 rs-h-s3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div class="jsrs-resizerPart" style="height: 60px">
                        <div
                          class="panel rs-maxw rs-h-s4 rs-h-s4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                      <div class="text-center">
                        <div
                          class="panel rs-inline-block rs-wd-s17 rs-wd-m23 rs-h-s3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
